import Message from '@uds/message';
import { FormattedNumber } from 'react-intl';
import { jsx } from 'react/jsx-runtime';
import merge from 'lodash.merge';
import { useBrandConfig } from '@ux/whitelabel';

const useShouldIncludeTax = () => {
  var _useBrandConfig, _useBrandConfig$payme;
  return (_useBrandConfig = useBrandConfig()) === null || _useBrandConfig === void 0 ? void 0 : (_useBrandConfig$payme = _useBrandConfig.payment) === null || _useBrandConfig$payme === void 0 ? void 0 : _useBrandConfig$payme.addTaxToDisplayPrice;
};
var useShouldIncludeTax$1 = useShouldIncludeTax;

const getId = _ref => {
  let {
    product
  } = _ref;
  return product === null || product === void 0 ? void 0 : product.id;
};
var getId$1 = getId;

const getName = _ref => {
  var _product$displayName;
  let {
    product
  } = _ref;
  return (_product$displayName = product === null || product === void 0 ? void 0 : product.displayName) != null ? _product$displayName : '';
};
var getName$1 = getName;

const getProductName = _ref => {
  var _product$name;
  let {
    product
  } = _ref;
  return (_product$name = product === null || product === void 0 ? void 0 : product.name) != null ? _product$name : '';
};
var getProductName$1 = getProductName;

const getDescription = _ref => {
  var _product$description;
  let {
    product
  } = _ref;
  return (_product$description = product === null || product === void 0 ? void 0 : product.description) != null ? _product$description : '';
};
var getDescription$1 = getDescription;

const getCategory = _ref => {
  var _product$categoryName;
  let {
    product
  } = _ref;
  return (_product$categoryName = product === null || product === void 0 ? void 0 : product.categoryName) != null ? _product$categoryName : '';
};
var getCategory$1 = getCategory;

const getTagline = _ref => {
  let {
    product
  } = _ref;
  return product === null || product === void 0 ? void 0 : product.tagline;
};
var getTagline$1 = getTagline;

const getProductType = _ref => {
  var _product$productType;
  let {
    product
  } = _ref;
  return (_product$productType = product === null || product === void 0 ? void 0 : product.productType) != null ? _product$productType : '';
};
const DOMAIN_REGEX = /^\/domains\/.*domain.*/;
const isDomain = _ref2 => {
  let {
    product
  } = _ref2;
  return DOMAIN_REGEX.test(getProductType({
    product
  }));
};

// this function pulls all of the raw price data together
// if you pass a term/interval it will attempt to find the price
// from the priceTiers property
// otherwise it'll just fall back to the default price

const getBasePrices = _ref => {
  var _product$priceTiers;
  let {
    product,
    term,
    interval
  } = _ref;
  const priceTiers = (_product$priceTiers = product === null || product === void 0 ? void 0 : product.priceTiers) != null ? _product$priceTiers : [];
  let priceTier;
  if (term != null && interval != null && priceTiers.length > 0) {
    priceTier = priceTiers.find(tier => {
      return tier.term === term && tier.paymentInterval === interval;
    });
  }
  if (priceTier == null) {
    // unlike price tiers, the default price doesn't contain the cancellation period
    // so we have to manually pull it out of the root product and merge it in
    priceTier = merge(product === null || product === void 0 ? void 0 : product.defaultPrice, {
      cancellationPeriod: product === null || product === void 0 ? void 0 : product.cancellationPeriod,
      cancellationPeriodType: product === null || product === void 0 ? void 0 : product.cancellationPeriodType
    });
  }
  return priceTier;
};
var getBasePrices$1 = getBasePrices;

const getCancellationPeriod = _ref => {
  let {
    product,
    term,
    interval
  } = _ref;
  const basePrices = getBasePrices$1({
    product,
    term,
    interval
  });
  return basePrices === null || basePrices === void 0 ? void 0 : basePrices.cancellationPeriod;
};
var getCancellationPeriod$1 = getCancellationPeriod;

const getTerm = _ref => {
  var _getBasePrices;
  let {
    product,
    term,
    interval
  } = _ref;
  return (_getBasePrices = getBasePrices$1({
    product,
    term,
    interval
  })) === null || _getBasePrices === void 0 ? void 0 : _getBasePrices.term;
};
var getTerm$1 = getTerm;

const getInterval = _ref => {
  var _prices$paymentInterv;
  let {
    product,
    term,
    interval
  } = _ref;
  const prices = getBasePrices$1({
    product,
    term,
    interval
  });
  return (_prices$paymentInterv = prices === null || prices === void 0 ? void 0 : prices.paymentInterval) != null ? _prices$paymentInterv : prices === null || prices === void 0 ? void 0 : prices.interval;
};
var getInterval$1 = getInterval;

const getPromotion = _ref => {
  var _promotion$priceTiers;
  let {
    product,
    term,
    interval
  } = _ref;
  const promotion = product === null || product === void 0 ? void 0 : product.promotionMessage;
  const priceTerm = getTerm$1({
    product,
    term,
    interval
  });
  const priceInterval = getInterval$1({
    product,
    term,
    interval
  });

  // promotions have a priceTiers object. If the term and interval do not
  // match then there is not a promo
  return promotion === null || promotion === void 0 ? void 0 : (_promotion$priceTiers = promotion.priceTiers) === null || _promotion$priceTiers === void 0 ? void 0 : _promotion$priceTiers.find(tier => {
    return tier.term === priceTerm && tier.paymentInterval === priceInterval;
  });
};
var getPromotion$1 = getPromotion;

const hasDiscount = _ref => {
  let {
    product,
    term,
    interval
  } = _ref;
  const promotion = getPromotion$1({
    product,
    term,
    interval
  });
  return promotion != null && Object.keys(promotion).length > 0;
};
var hasDiscount$1 = hasDiscount;

const getPromotionalPrice$1 = _ref => {
  let {
    product,
    term,
    interval
  } = _ref;
  if (hasDiscount$1({
    product,
    term,
    interval
  })) {
    var _getPromotion;
    return (_getPromotion = getPromotion$1({
      product,
      term,
      interval
    })) === null || _getPromotion === void 0 ? void 0 : _getPromotion.discountedPrice;
  }
  return null;
};
const getRawPrices = _ref2 => {
  var _ref3, _basePrices$retail;
  let {
    product,
    term,
    interval
  } = _ref2;
  const basePrices = getBasePrices$1({
    product,
    term,
    interval
  });
  const promotional = getPromotionalPrice$1({
    product,
    term,
    interval
  });
  const retail = (_ref3 = (_basePrices$retail = basePrices === null || basePrices === void 0 ? void 0 : basePrices.retail) != null ? _basePrices$retail : basePrices === null || basePrices === void 0 ? void 0 : basePrices.retailPrice) != null ? _ref3 : basePrices === null || basePrices === void 0 ? void 0 : basePrices.price;
  const upFront = basePrices === null || basePrices === void 0 ? void 0 : basePrices.upFrontCost;
  const recurring = basePrices === null || basePrices === void 0 ? void 0 : basePrices.recurringCost;
  const firstTerm = basePrices === null || basePrices === void 0 ? void 0 : basePrices.firstTermCost;
  const result = {
    retail,
    upFront,
    recurring,
    firstTerm,
    promotional
  };

  // strip out null/undefined properties from the result
  Object.keys(result).forEach(key => {
    if (result[key] == null) {
      delete result[key];
    }
  });
  return result;
};
var getRawPrices$1 = getRawPrices;

const getCurrency = _ref => {
  var _getRawPrices, _Object$values$, _Object$values$$gross;
  let {
    product,
    term,
    interval
  } = _ref;
  const prices = (_getRawPrices = getRawPrices$1({
    product,
    term,
    interval
  })) != null ? _getRawPrices : {};
  return (_Object$values$ = Object.values(prices)[0]) === null || _Object$values$ === void 0 ? void 0 : (_Object$values$$gross = _Object$values$.gross) === null || _Object$values$$gross === void 0 ? void 0 : _Object$values$$gross.currency;
};
var getCurrency$1 = getCurrency;

let ViewMode;
(function (ViewMode) {
  ViewMode[ViewMode["RETAIL_AND_UPFRONT"] = 0] = "RETAIL_AND_UPFRONT";
  ViewMode[ViewMode["RETAIL_INCLUDES_UPFRONT"] = 1] = "RETAIL_INCLUDES_UPFRONT";
  ViewMode[ViewMode["RETAIL_ONLY"] = 2] = "RETAIL_ONLY";
})(ViewMode || (ViewMode = {}));
let DiscountInterval;
(function (DiscountInterval) {
  DiscountInterval[DiscountInterval["EVERGREEN"] = -1] = "EVERGREEN";
})(DiscountInterval || (DiscountInterval = {}));
const INTLNAMESPACE = 'ux.product';

const getTaxProperty = includeTax => {
  switch (includeTax) {
    case 'taxOnly':
      return 'tax';
    case true:
      return 'gross';
    default:
      return 'net';
  }
};
const getPrices = _ref => {
  var _getRawPrices;
  let {
    product,
    term,
    interval,
    includeTax
  } = _ref;
  const taxProperty = getTaxProperty(includeTax != null ? includeTax : true);
  const rawPrices = (_getRawPrices = getRawPrices$1({
    product,
    term,
    interval
  })) != null ? _getRawPrices : {};
  return Object.entries(rawPrices).reduce((acc, _ref2) => {
    let [key, value] = _ref2;
    return {
      ...acc,
      [key]: value === null || value === void 0 ? void 0 : value[taxProperty].amount
    };
  }, {});
};
var getPrices$1 = getPrices;

const adjustPriceByDisplayPeriod = _ref => {
  let {
    price,
    interval,
    displayInterval
  } = _ref;
  if (interval == null) {
    return price;
  }
  // when display period matches the price's interval we don't need to adjust
  if (interval === displayInterval) {
    return price;
  }
  // when want to display in a different interval than the product's
  if (displayInterval === 1 || displayInterval === 12) {
    return price / interval * displayInterval;
  }
  return price;
};
const getPriceByType = _ref2 => {
  var _prices$type;
  let {
    product,
    term,
    interval,
    includeTax,
    displayInterval,
    type,
    withDisplay
  } = _ref2;
  const prices = getPrices$1({
    product,
    term,
    interval,
    includeTax
  });
  let price = (_prices$type = prices === null || prices === void 0 ? void 0 : prices[type]) != null ? _prices$type : 0;
  if (displayInterval != null && withDisplay) {
    price = adjustPriceByDisplayPeriod({
      price,
      interval: getInterval$1({
        product,
        term,
        interval
      }),
      displayInterval
    });
  }
  return price;
};
const getRetailPrice = _ref3 => {
  let {
    product,
    ...options
  } = _ref3;
  return getPriceByType({
    product,
    ...options,
    type: 'retail',
    withDisplay: true
  });
};
const getUpFrontPrice = _ref4 => {
  let {
    product,
    ...options
  } = _ref4;
  return getPriceByType({
    product,
    ...options,
    type: 'upFront',
    withDisplay: false
  });
};
const getFirstTermPrice = _ref5 => {
  let {
    product,
    ...options
  } = _ref5;
  return getPriceByType({
    product,
    ...options,
    type: 'firstTerm',
    withDisplay: true
  });
};
const getPromotionalPrice = _ref6 => {
  let {
    product,
    ...options
  } = _ref6;
  return getPriceByType({
    product,
    ...options,
    type: 'promotional',
    withDisplay: true
  });
};

const getPrice = _ref => {
  let {
    product,
    viewMode,
    ...options
  } = _ref;
  // get the "standard price" this will either be the retail price or the promotional price
  let price = hasDiscount$1({
    product,
    ...options
  }) ? getPromotionalPrice({
    product,
    ...options
  }) : getRetailPrice({
    product,
    ...options
  });
  if (viewMode === ViewMode.RETAIL_INCLUDES_UPFRONT) {
    price = price + getUpFrontPrice({
      product,
      ...options
    });
  }
  return price;
};
var getPrice$1 = getPrice;

const getPromotionalRate = _ref => {
  var _promotion$percentOff;
  let {
    product,
    term,
    interval
  } = _ref;
  const promotion = getPromotion$1({
    product,
    term,
    interval
  });
  return (_promotion$percentOff = promotion === null || promotion === void 0 ? void 0 : promotion.percentOff) != null ? _promotion$percentOff : 0;
};
var getPromotionalRate$1 = getPromotionalRate;

const getTax$1 = _ref => {
  let {
    product,
    ...options
  } = _ref;
  return getPrice$1({
    product,
    ...options,
    includeTax: 'taxOnly'
  });
};
var getTax$2 = getTax$1;

const calcPerc = (net, gross) => {
  const perc = ((gross - net) / net * 100).toFixed(0);
  return net && gross ? perc : '—';
};
const getTaxRate = _ref => {
  let {
    product,
    ...options
  } = _ref;
  const netPrice = getPrice$1({
    product,
    ...options,
    includeTax: false
  });
  const grossPrice = getPrice$1({
    product,
    ...options,
    includeTax: true
  });
  return calcPerc(netPrice, grossPrice);
};
var getTaxRate$1 = getTaxRate;

const hasUpFrontCost = _ref => {
  let {
    product,
    term,
    interval,
    displayInterval,
    includeTax
  } = _ref;
  return getUpFrontPrice({
    product,
    term,
    interval,
    displayInterval,
    includeTax
  }) > 0;
};
var hasUpFrontCost$1 = hasUpFrontCost;

const getDiscountInterval = _ref => {
  var _product$promotionMes;
  let {
    product
  } = _ref;
  return product === null || product === void 0 ? void 0 : (_product$promotionMes = product.promotionMessage) === null || _product$promotionMes === void 0 ? void 0 : _product$promotionMes.discountInterval;
};
var getDiscountInterval$1 = getDiscountInterval;

const getRecurringPrice = _ref => {
  let {
    product,
    ...options
  } = _ref;
  const discountInterval = getDiscountInterval$1({
    product
  });
  const price = getPrice$1({
    product,
    ...options
  });
  const recurringPrice = getPriceByType({
    product,
    ...options,
    type: 'recurring',
    withDisplay: true
  });
  return discountInterval === DiscountInterval.EVERGREEN ? price : recurringPrice;
};
var getRecurringPrice$1 = getRecurringPrice;

// is the basket item's current term/interval the default price tier?
const isDefaultPrice = (item, product) => {
  var _product$defaultPrice, _product$defaultPrice2;
  const interval = product === null || product === void 0 ? void 0 : (_product$defaultPrice = product.defaultPrice) === null || _product$defaultPrice === void 0 ? void 0 : _product$defaultPrice.interval;
  const term = product === null || product === void 0 ? void 0 : (_product$defaultPrice2 = product.defaultPrice) === null || _product$defaultPrice2 === void 0 ? void 0 : _product$defaultPrice2.term;
  return item.paymentInterval === interval && item.term === term;
};
const mergeDefaultPrice = (item, product) => {
  return {
    ...product,
    defaultPrice: merge(product.defaultPrice, {
      retailPrice: item.priceBeforeAdjustments,
      firstTermCost: item.firstTermCost,
      recurringCost: item.recurringCost,
      upFrontCost: item.upfrontCost
    })
  };
};

// is the basket item's current term/interval the same as this tier?
const isTierPrice = (item, tier) => {
  return item.paymentInterval === tier.paymentInterval && item.term === tier.term;
};

// generate a tier from the basket item's price data
const createTier = (item, tier) => {
  return {
    ...tier,
    paymentInterval: item.paymentInterval,
    term: item.term,
    firstTermCost: item.firstTermCost,
    price: item.priceBeforeAdjustments,
    recurringCost: item.recurringCost,
    upFrontCost: item.upfrontCost
  };
};

// does the basket item have price adjustments?
const hasAdjustments = item => {
  return item.totalAdjustmentValue.gross.amount > 0;
};

// generate a tier from the basket item's price data
const createPromotionTier = item => {
  const {
    term,
    paymentInterval,
    totalPrice: totalDiscountedPrice,
    // unit equivalent of totalPrice, only available for baskets created after multiquantity PPE changes
    priceWithAdjustments: unitDiscountedPrice,
    totalAdjustmentValue: totalDiscountAmount,
    // unit equivalent of AdjustmentValue, only available for baskets created after multiquantity PPE changes
    unitAdjustmentValue: unitDiscountAmount,
    orderItemPriceDetails: [{
      percentOff
    }]
  } = item;
  const discountedPrice = unitDiscountedPrice ? unitDiscountedPrice : totalDiscountedPrice;
  const discountAmount = unitDiscountAmount ? unitDiscountAmount : totalDiscountAmount;
  return {
    term,
    paymentInterval,
    discountedPrice,
    discountAmount,
    percentOff
  };
};

// find which price tier the basket item is currently set to
// and override it with the basket's pricing
const mergePrice = (item, product) => {
  var _product$priceTiers;
  if (isDefaultPrice(item, product)) {
    return mergeDefaultPrice(item, product);
  }
  // loop through the price tiers to see if we can find a match
  const priceTiers = ((_product$priceTiers = product.priceTiers) != null ? _product$priceTiers : []).map(tier => {
    if (isTierPrice(item, tier)) {
      return createTier(item, tier);
    }
    return tier;
  });
  return {
    ...product,
    priceTiers
  };
};

// if the basket item has adjustments, we treat this as if it was on offer
// if the product doesn't have any offers, we just create a bespoke one
const mergePromotions = (item, product) => {
  var _normalizedProduct, _normalizedProduct$pr, _normalizedProduct2, _normalizedProduct2$p;
  let found = false;
  const isAdjusted = hasAdjustments(item);
  let normalizedProduct = product;

  // if for some reason priceTiers isn't set (it has happened),
  // we should default it
  normalizedProduct = {
    ...normalizedProduct,
    promotionMessage: {
      ...((_normalizedProduct = normalizedProduct) === null || _normalizedProduct === void 0 ? void 0 : _normalizedProduct.promotionMessage),
      priceTiers: ((_normalizedProduct$pr = (_normalizedProduct2 = normalizedProduct) === null || _normalizedProduct2 === void 0 ? void 0 : (_normalizedProduct2$p = _normalizedProduct2.promotionMessage) === null || _normalizedProduct2$p === void 0 ? void 0 : _normalizedProduct2$p.priceTiers) != null ? _normalizedProduct$pr : []).reduce((acc, tier) => {
        // if the price tier matches the basket's term/interval
        // we want to replace it with the basket's actual pricing
        if (isTierPrice(item, tier)) {
          found = true;
          // if the product has an offer for this tier
          // but the basket doesn't have any adjustments
          // that means that the offer isn't valid for this customer
          // so we should remove it from the price tiers
          if (!isAdjusted) {
            return acc;
          }
          return [...acc, createPromotionTier(item)];
        }
        return [...acc, tier];
      }, [])
    }
  };

  // if the currently-selected term/interval doesn't match a promotion tier
  // we want to force a new one onto the product
  if (!found && isAdjusted) {
    var _normalizedProduct3, _normalizedProduct$pr2, _normalizedProduct4, _normalizedProduct4$p;
    normalizedProduct = {
      ...normalizedProduct,
      promotionMessage: {
        ...((_normalizedProduct3 = normalizedProduct) === null || _normalizedProduct3 === void 0 ? void 0 : _normalizedProduct3.promotionMessage),
        priceTiers: [...((_normalizedProduct$pr2 = (_normalizedProduct4 = normalizedProduct) === null || _normalizedProduct4 === void 0 ? void 0 : (_normalizedProduct4$p = _normalizedProduct4.promotionMessage) === null || _normalizedProduct4$p === void 0 ? void 0 : _normalizedProduct4$p.priceTiers) != null ? _normalizedProduct$pr2 : []), createPromotionTier(item)]
      }
    };
  }
  return normalizedProduct;
};

// a  basket item contains a PPE product, but it has its own
// pricing fields, which take precedence over the PPE data
// this selector merges the basket item pricing into the
// PPE object
const getBasketItemProduct = basketItem => {
  const product = basketItem.product;
  if (product == null) {
    return product;
  }

  // Don't mutate original basketItem product; its generally a
  // bad idea to have side effects but specifically this can
  // cause issues where there is one product for different basket items
  // and you end up altering the orignal product and effecting both items pricing
  let basketItemProduct = JSON.parse(JSON.stringify(product));
  basketItemProduct = mergePrice(basketItem, basketItemProduct);
  basketItemProduct = mergePromotions(basketItem, basketItemProduct);
  return basketItemProduct;
};
var getBasketItemProduct$1 = getBasketItemProduct;

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useShouldIncludeTax: useShouldIncludeTax$1,
  getId: getId$1,
  getName: getName$1,
  getProductName: getProductName$1,
  getDescription: getDescription$1,
  getCategory: getCategory$1,
  getTagline: getTagline$1,
  getProductType: getProductType,
  isDomain: isDomain,
  getCancellationPeriod: getCancellationPeriod$1,
  getCurrency: getCurrency$1,
  getInterval: getInterval$1,
  getPrice: getPrice$1,
  getPrices: getPrices$1,
  getPromotionalRate: getPromotionalRate$1,
  getTax: getTax$2,
  getTaxRate: getTaxRate$1,
  getTerm: getTerm$1,
  hasDiscount: hasDiscount$1,
  hasUpFrontCost: hasUpFrontCost$1,
  getRecurringPrice: getRecurringPrice$1,
  getFirstTermPrice: getFirstTermPrice,
  getPromotionalPrice: getPromotionalPrice,
  getRetailPrice: getRetailPrice,
  getUpFrontPrice: getUpFrontPrice,
  getBasketItemProduct: getBasketItemProduct$1
});

// ux.product.renewalPeriod.{yearly,monthly,nMonthly}
// per year / per month / every n months
const RenewalPeriod = _ref => {
  let {
    intlNamespace = INTLNAMESPACE,
    period
  } = _ref;
  let frequency = 'nMonthly';
  if (period === 12) {
    frequency = 'yearly';
  }
  if (period === 1) {
    frequency = 'monthly';
  }
  return /*#__PURE__*/jsx(Message, {
    id: `${intlNamespace}.renewalPeriod.${frequency}`,
    values: {
      period
    }
  });
};
var RenewalPeriod$1 = RenewalPeriod;

const RenewalMessage = _ref => {
  let {
    intlNamespace = INTLNAMESPACE,
    interval,
    currency,
    price,
    upFront,
    recurring,
    term
  } = _ref;
  const years = Math.floor(term / 12);
  const months = term % 12;
  const differs = price !== recurring;

  // the price, either the discount price or the retail price
  // £9.99
  const priceNumber = /*#__PURE__*/jsx(FormattedNumber, {
    value: price,
    style: "currency",
    currency: currency
  });
  // the price after the initial period has ended
  // £19.99
  const recurringNumber = /*#__PURE__*/jsx(FormattedNumber, {
    value: recurring,
    style: "currency",
    currency: currency
  });
  // per month
  const periodComponent = /*#__PURE__*/jsx(RenewalPeriod$1, {
    intlNamespace: intlNamespace,
    period: interval != null ? interval : 1
  });
  // ux.product.recurring.price
  // shown when the renewal price is different to the first term price
  // , then £19.99 per month
  const recurringMessage = (() => {
    if (recurring === price || recurring === 0) {
      return '';
    }
    return /*#__PURE__*/jsx(Message, {
      id: `${intlNamespace}.recurring.price`,
      values: {
        price: recurringNumber,
        period: periodComponent
      }
    });
  })();
  // ux.product.term.{months,years,monthsAndYears}
  // 2 years / 6 months / 2 years and 6 months
  const termMessage = (() => {
    if (term < 12) {
      return /*#__PURE__*/jsx(Message, {
        id: `${intlNamespace}.term.months`,
        values: {
          months
        }
      });
    }
    if (term % 12 === 0) {
      return /*#__PURE__*/jsx(Message, {
        id: `${intlNamespace}.term.years`,
        values: {
          years
        }
      });
    }
    return /*#__PURE__*/jsx(Message, {
      id: `${intlNamespace}.term.monthsAndYears`,
      values: {
        months,
        years
      }
    });
  })();
  // the setup fee
  // £50
  const feeNumber = /*#__PURE__*/jsx(FormattedNumber, {
    value: upFront,
    style: "currency",
    currency: currency
  });
  // ux.product.fee
  // will not display if there isn't a fee
  // Setup fee: £50
  const feeMessage = upFront != null && upFront > 0 ? /*#__PURE__*/jsx(Message, {
    id: `${intlNamespace}.fee`,
    values: {
      price: feeNumber
    }
  }) : null;

  // ux.product.recurring
  return /*#__PURE__*/jsx(Message, {
    id: `${intlNamespace}.recurring`,
    values: {
      price: priceNumber,
      recurringPrice: recurringMessage,
      term: termMessage,
      period: periodComponent,
      fee: feeMessage,
      differs
    }
  });
};
var RenewalMessage$1 = RenewalMessage;

const useProductPrice = props => {
  const {
    interval,
    term,
    displayInterval
  } = props;
  return {
    currency: getCurrency$1(props),
    price: getPrice$1(props),
    upFront: getUpFrontPrice(props),
    recurring: getRecurringPrice$1(props),
    retail: getRetailPrice(props),
    discount: getPromotionalPrice(props),
    discountPerc: getPromotionalRate$1(props),
    taxRate: getTaxRate$1(props),
    hasUpFrontCost: hasUpFrontCost$1(props),
    hasDiscount: hasDiscount$1(props),
    interval: interval != null ? interval : getInterval$1(props),
    term: term != null ? term : getTerm$1(props),
    displayInterval: displayInterval != null ? displayInterval : getInterval$1(props)
  };
};
var useProductPrice$1 = useProductPrice;

const getTax = _ref => {
  let {
    includeTax,
    taxRate,
    intlNamespace
  } = _ref;
  if (taxRate === '—' || taxRate === '0') {
    return '';
  }
  if (includeTax) {
    return (
      /*#__PURE__*/
      // ux.product.legal.tax.inc
      // includes tax at 20%
      jsx(Message, {
        id: `${intlNamespace}.legal.tax.inc`,
        values: {
          taxPerc: `${taxRate}%`
        }
      })
    );
  }
  return (
    /*#__PURE__*/
    // ux.product.legal.tax.exc
    // excludes tax at 20%
    jsx(Message, {
      id: `${intlNamespace}.legal.tax.exc`,
      values: {
        taxPerc: `${taxRate}%`
      }
    })
  );
};
const getRecurring = _ref2 => {
  let {
    intlNamespace,
    term,
    interval,
    displayInterval,
    currency,
    price,
    upFront,
    recurring
  } = _ref2;
  if (term == null || interval == null) {
    return null;
  }
  if (term > 0 && interval > 0) {
    return /*#__PURE__*/jsx(RenewalMessage$1, {
      intlNamespace: intlNamespace,
      term: term,
      interval: displayInterval,
      currency: currency,
      price: price,
      upFront: upFront,
      recurring: recurring
    });
  }
  return null;
};
const LegalText = _ref3 => {
  var _ref4;
  let {
    intlNamespace = INTLNAMESPACE,
    ...props
  } = _ref3;
  const {
    product,
    bespoke
  } = props;
  const includeTax = useShouldIncludeTax$1();
  const {
    currency,
    price,
    upFront,
    recurring,
    taxRate,
    interval,
    term,
    displayInterval
  } = useProductPrice$1({
    includeTax,
    ...props
  });
  const cancellation = getCancellationPeriod$1({
    product,
    term,
    interval
  });

  // {tax}{recurring}{bespoke}{cancellation}
  // includes 20% tax
  return /*#__PURE__*/jsx(Message, {
    id: `${intlNamespace}.legal`,
    values: {
      tax: getTax({
        intlNamespace,
        includeTax,
        taxRate
      }),
      recurring: getRecurring({
        intlNamespace,
        term,
        interval,
        displayInterval,
        currency,
        price,
        upFront,
        recurring
      }),
      bespoke: (_ref4 = bespoke != null ? bespoke : product === null || product === void 0 ? void 0 : product.legalText) != null ? _ref4 : '',
      // ux.product.legal.cancellation
      // 4 weeks notice
      cancellation: cancellation != null ? /*#__PURE__*/jsx(Message, {
        id: `${intlNamespace}.legal.cancellation`,
        values: {
          cancellation
        }
      }) : null
    }
  });
};
var LegalText$1 = LegalText;

const price = function () {
  let amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  return {
    amount,
    currency: 'GBP'
  };
};
const prices = function () {
  let net = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  let taxRate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.2;
  return {
    raw: price(net),
    net: price(net),
    tax: price(net * taxRate),
    gross: price(net + net * taxRate)
  };
};
const priceTier = function () {
  let {
    retail = 10,
    firstTerm = retail,
    recurring = retail,
    upfront = 0,
    interval = 1,
    term = 12,
    taxRate = 0.2
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    cancellationPeriodType: '',
    hidden: false,
    legacyTariffId: '',
    minQuantity: 1,
    term,
    paymentInterval: interval,
    cancellationPeriod: '4 weeks',
    price: prices(retail, taxRate),
    upFrontCost: prices(upfront, taxRate),
    recurringCost: prices(recurring, taxRate),
    firstTermCost: prices(firstTerm, taxRate)
  };
};
const promotionPriceTier = _ref => {
  let {
    term = 12,
    interval = 1,
    retail = 10,
    offer = retail / 2,
    taxRate = 0.2
  } = _ref;
  return {
    term,
    paymentInterval: interval,
    discountedPrice: prices(offer, taxRate),
    discountAmount: prices(retail - offer, taxRate),
    percentOff: Math.round(offer / retail * 100)
  };
};
const promotionMessage = function () {
  let {
    term = 12,
    interval = 1,
    retail = 10,
    offer = retail / 2,
    taxRate = 0.2,
    tiers = [promotionPriceTier({
      term,
      interval,
      offer,
      retail,
      taxRate
    })]
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    offerType: '',
    discountType: '',
    discountValue: 5,
    percentOff: 50,
    discountAmount: prices(5, taxRate),
    message: '',
    messagePlacement: '',
    priority: 0,
    media: {
      allowOverrideUrl: false,
      id: 1,
      url: '',
      archived: ''
    },
    discountedPrice: prices(5, taxRate),
    priceTiers: tiers
  };
};
const defaultPrice = function () {
  let {
    interval = 1,
    term = 12,
    retail = 10,
    firstTerm = retail,
    recurring = retail,
    upfront = 0,
    taxRate = 0.2
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    term,
    interval,
    retailPrice: prices(retail, taxRate),
    upFrontCost: prices(upfront, taxRate),
    recurringCost: prices(recurring, taxRate),
    firstTermCost: prices(firstTerm, taxRate)
  };
};
const productAttribute = function () {
  let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'name';
  let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  return {
    attributeName: name,
    attributeValue: value,
    id: Math.random() * 1024
  };
};
const product = function () {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    id: 1234,
    name: 'name',
    url: '/url',
    activeStartDate: '',
    externalId: '',
    displayName: 'display name',
    productType: '',
    tagline: '',
    keywords: '',
    legalText: '',
    isEntitlement: false,
    isOptimisticProvision: false,
    cancellationPeriod: '4 weeks',
    cancellationPeriodType: '4_WEEKS',
    defaultPrice: defaultPrice({
      firstTerm: 10,
      interval: 1,
      term: 12,
      recurring: 10,
      retail: 10,
      upfront: 0
    }),
    defaultSkuId: 1,
    categoryName: 'category',
    priceTiers: [priceTier({
      term: 12,
      interval: 12,
      retail: 120
    })],
    productAttributes: [],
    ...overrides
  };
};

var mocks = /*#__PURE__*/Object.freeze({
  __proto__: null,
  price: price,
  prices: prices,
  priceTier: priceTier,
  promotionPriceTier: promotionPriceTier,
  promotionMessage: promotionMessage,
  defaultPrice: defaultPrice,
  productAttribute: productAttribute,
  product: product
});

export { LegalText$1 as LegalText, RenewalMessage$1 as RenewalMessage, RenewalPeriod$1 as RenewalPeriod, ViewMode, mocks, index as selectors, useProductPrice$1 as useProductPrice };
